import React from 'react';
import { observer } from 'mobx-react-lite';
import { BonusCreationState } from 'src/domains/casino/webview/bonus-engine/bonus-creator/bonus-creation/BonusCreation.state';
import { MultiSelectList } from 'src/domains/common/components/multi-select-list/multi-select-list';
import { CampaignCreatorState } from 'src/domains/casino/webview/bonus-engine/campaign/CampaignCreator.state';

interface PlayThroughPickerPropsType {
    state: BonusCreationState | CampaignCreatorState;
    disabled?: boolean;
}

export const PlayThroughPicker = observer((props: PlayThroughPickerPropsType): JSX.Element => {
    const playThroughEligibleGamesState =
        props.state.rewardConditionsState.casinoSectionState.playThroughEligibleGamesState;
    const {
        showAllBadges,
        expanded,
        visibleCheckedWithLabels,
        visibleChecked,
        filteredNodes,
        keywordInputState,
        checked,
        toggleShowAllBadges,
        clearChecked,
        handleCheck,
        handleExpand,
        setKeyword,
        handleRemoveChecked,
    } = playThroughEligibleGamesState;

    return (
        <div className='flex flex-col gap-2'>
            <label className='text-sm'>Playthrough Eligible Games</label>
            <MultiSelectList
                filteredNodes={filteredNodes}
                showAllBadges={showAllBadges}
                checked={checked}
                visibleChecked={visibleChecked}
                keywordInputState={keywordInputState}
                expanded={expanded}
                visibleCheckedWithLabels={visibleCheckedWithLabels}
                toggleShowAllBadges={toggleShowAllBadges}
                clearChecked={clearChecked}
                handleCheck={handleCheck}
                handleExpand={handleExpand}
                setKeyword={setKeyword}
                handleRemoveChecked={handleRemoveChecked}
                remaining={visibleChecked.remaining}
                remainingLabel='Items'
                disabled={props.disabled}
            />
        </div>
    );
});
